module.exports = __webpack_public_path__ + "img/51.bf52b79e.jpg";